import { SWMS_SHIFT_PRE_START_CHECKLIST_URL } from "../../dataProvider/constant";
import { scopeApiInstance } from "../../dataProvider/axiosHelper";
import { Strings } from "../../dataProvider/localize";

const getApiErrorMessage = (error) => {
  if (error && error.response && error.response.data && error.response.data.message) {
    return error.response.data.message;
  }

  return error ? Strings.network_error : null;
};

const hasRequiredContext = (jobId, shiftId, swmsId) => {
  return jobId !== undefined
    && jobId !== null
    && `${jobId}`.trim() !== ""
    && shiftId !== undefined
    && shiftId !== null
    && `${shiftId}`.trim() !== ""
    && swmsId !== undefined
    && swmsId !== null
    && `${swmsId}`.trim() !== "";
};

export const getJobShiftEmergencyReadiness = (jobId, shiftId, swmsId, abortController = {}) => () => {
  if (!hasRequiredContext(jobId, shiftId, swmsId)) {
    return Promise.reject(Strings.generic_error);
  }

  return scopeApiInstance.get(
    `${SWMS_SHIFT_PRE_START_CHECKLIST_URL}/${jobId}/shifts/${shiftId}/swms/${swmsId}/rescue-readiness-questions`,
    { ...abortController }
  ).then((res) => {
    if (res && res.data) {
      return Promise.resolve(res.data.data || res.data);
    }

    return Promise.reject(Strings.generic_error);
  }).catch((error) => Promise.reject(getApiErrorMessage(error)));
};

export const saveJobShiftEmergencyReadiness = (jobId, shiftId, swmsId, payload) => () => {
  if (!hasRequiredContext(jobId, shiftId, swmsId) || !payload) {
    return Promise.reject(Strings.generic_error);
  }

  return scopeApiInstance.put(
    `${SWMS_SHIFT_PRE_START_CHECKLIST_URL}/${jobId}/shifts/${shiftId}/swms/${swmsId}/rescue-readiness-questions`,
    payload
  ).then((res) => {
    if (res && res.data) {
      return Promise.resolve(res.data.data || res.data);
    }

    return Promise.reject(Strings.generic_error);
  }).catch((error) => Promise.reject(getApiErrorMessage(error)));
};


export const generateJobShiftEmergencyReadinessPdf = (jobId, shiftId, swmsId) => () => {
  if (!hasRequiredContext(jobId, shiftId, swmsId)) {
    return Promise.reject(Strings.generic_error);
  }

  return scopeApiInstance.post(
    `${SWMS_SHIFT_PRE_START_CHECKLIST_URL}/${jobId}/shifts/${shiftId}/swms/${swmsId}/rescue-readiness-questions/pdf`,
    {}
  ).then((res) => {
    if (res && res.data) {
      return Promise.resolve(res.data.data || res.data);
    }

    return Promise.reject(Strings.generic_error);
  }).catch((error) => Promise.reject(getApiErrorMessage(error)));
};
